var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoffee(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23,5a3,3,0,0,0-3-3h-.171A3.006,3.006,0,0,0,17,0H7A3.006,3.006,0,0,0,4.171,2H4A3,3,0,0,0,2.022,7.238L3.57,19.62A5.007,5.007,0,0,0,8.531,24h6.938a5.008,5.008,0,0,0,4.961-4.38L21.978,7.238A2.981,2.981,0,0,0,23,5Zm-3.883,9h-3.2c-.892-5.287-6.947-5.284-7.838,0h-3.2l-.75-6H19.867ZM14,15c-.105,3.954-3.895,3.953-4,0C10.105,11.046,13.9,11.047,14,15ZM4,4H5A1,1,0,0,0,6,3,1,1,0,0,1,7,2H17a1,1,0,0,1,1,1,1,1,0,0,0,1,1h1a1,1,0,0,1,0,2H4A1,1,0,0,1,4,4ZM18.445,19.372A3,3,0,0,1,15.469,22H8.531a3,3,0,0,1-2.977-2.628L5.133,16H8.081c.892,5.287,6.948,5.284,7.838,0h2.948Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffee);
export default __webpack_public_path__ + "static/media/coffee.38babb8079f4d8c16a7863e7ff499541.svg";
export { ForwardRef as ReactComponent };